import { useLocation } from 'react-router-dom';
import { MessageCircleMore, Phone } from 'lucide-react';
import { PHONE_HREF, PHONE_DISPLAY, WHATSAPP_HREF } from '../../lib/contact';

const HIDDEN_PATHS = new Set(['/cookie', '/datenschutz', '/impressum']);

export default function MobileStickyCTA() {
  const location = useLocation();

  if (HIDDEN_PATHS.has(location.pathname)) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9990] border-t border-[#2f2720] bg-[#120f0d]/96 px-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] pt-3 shadow-[0_-12px_30px_rgba(15,10,6,0.28)] backdrop-blur md:hidden">
      <div className="mx-auto flex max-w-6xl items-center gap-2">
        <a
          href={PHONE_HREF}
          aria-label={`Jetzt anrufen unter ${PHONE_DISPLAY}`}
          className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-full border border-amber-300/40 bg-[#f2bf63] px-4 py-3 text-sm font-semibold text-[#1c140d] shadow-[0_14px_32px_rgba(242,191,99,0.28)] transition-colors hover:bg-[#ffcf82]"
        >
          <Phone className="h-4 w-4" aria-hidden="true" />
          Jetzt anrufen
        </a>
        <a
          href={WHATSAPP_HREF}
          aria-label="WhatsApp schreiben"
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-full border border-[#2f2720] bg-[#1a1512] px-4 py-3 text-sm font-semibold text-[#f5eadb] transition-colors hover:border-amber-300/50 hover:text-amber-300"
        >
          <MessageCircleMore className="h-4 w-4" aria-hidden="true" />
          WhatsApp
        </a>
      </div>
    </div>
  );
}
